import { QueryCache, QueryClient } from 'react-query';

const sharedQueryCache = new QueryCache();
export const queryClient = new QueryClient({
  queryCache: sharedQueryCache,
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60 * 5,
    },
  },
});
